<header>
  <app-header  isWavier=true headerName="Registration Details"></app-header>
</header>
<div class="resident-wrapper">
  <div class="outer-conatiner">
    <div class="inner-container form-container">
      <app-page-title class="test" pageTitle='Overnight Parking Waiver Request'
        subPageTitle='Please provide the following information to request an overnight parking waiver.'>
      </app-page-title>
      <div class="sub-form-title mandator-title">* All fields are required</div>
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit(formDirective)" #formDirective="ngForm">
        <div class="container-wrapper">
          <mat-form-field appearance="fill">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" required pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$">
            <mat-error *ngIf="registerForm.get('email').hasError('required') || registerForm.get('email').hasError('pattern')">
              Please enter email
            </mat-error>
          </mat-form-field>
          <!-- <p *ngIf="!registerForm.get('email').hasError('required') && !registerForm.get('email').hasError('pattern')">
            {{registerMessage }}</p>
            <mat-error style="text-align: left; font-size: 75%; padding: 0px 35px;" *ngIf="!registerForm.get('email').hasError('required') && registerForm.get('email').hasError('pattern')">
               Please enter valid email
             </mat-error> -->
          <!-- <mat-error style="text-align: left; font-size: 75%; padding: 0px 35px;"
            *ngIf="registerForm.get('email').hasError('email') && !registerForm.get('email').hasError('required')">
            Please enter a valid <strong>Email</strong>
          </mat-error> -->
          <mat-form-field appearance="fill">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" required />
            <mat-error *ngIf="registerForm.get('firstName').hasError('required')">
              Please enter first name
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" required />
            <mat-error *ngIf="registerForm.get('lastName').hasError('required')">
              Please enter last name
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field appearance="fill">
                        <mat-label>Street Name</mat-label>
                            <input type="text"
                            placeholder="Pick one street name"
                            aria-label="Number"
                            matInput
                            formControlName="street"
                            [matAutocomplete]="auto">
                     <mat-autocomplete #auto="matAutocomplete">
                       <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                         {{option}}
                       </mat-option>
                     </mat-autocomplete>
                     <mat-error *ngIf="registerForm.get('street').hasError('required')">
                        Please select
                        <strong>Street Name</strong>
                      </mat-error>                        
                     </mat-form-field>
                     <mat-form-field appearance="fill">
                        <mat-label>Street Number</mat-label>
                        <mat-select formControlName="streetNumber" required>
                           <mat-option [value]="city" *ngFor="let city of streetNumber" >{{city}}</mat-option>
                        </mat-select>
                           <mat-error *ngIf="registerForm.get('streetNumber').hasError('required')">
                              Please select
                              <strong>Street Number</strong>
                            </mat-error>                         
                     </mat-form-field> -->

                     <!-- <p class="sub-form-title adr-cls">Address</p> -->
                     <mat-form-field appearance="fill">
                      <mat-label>Address</mat-label>
                      <input matInput formControlName="address" required />
                      <mat-error *ngIf="registerForm.get('address').hasError('required')">
                        Please enter address
                      </mat-error>
                    </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city" required />
                           <mat-error *ngIf="registerForm.get('city').hasError('required')">
                              Please enter city
                            </mat-error>   
                     </mat-form-field>
                     <mat-form-field  appearance="fill">
                        <mat-label>State</mat-label>
                        <mat-select  formControlName="stateId" required>
                           <mat-option  *ngFor="let state of states" [value]="state.id">{{state.state}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="registerForm.get('stateId').hasError('required')">
                           Please select state
                         </mat-error>
                     </mat-form-field>
                     <mat-form-field  appearance="fill">
                        <mat-label>Zip Code</mat-label>
                        <input matInput formControlName="zipcode" [(ngModel)]="zip_code" pattern="^\d*[0-9]\d*$" minlength="5" maxlength="5" required/>
                        <mat-error *ngIf="registerForm.get('zipcode').hasError('required')">
                           Please enter zip Code
                         </mat-error>
                         <mat-error *ngIf="zip_code?.length < 5 && !registerForm.get('zipcode').hasError('required')">
                          Please enter 5 digit number
                        </mat-error>
                     </mat-form-field>
                     <!-- <mat-form-field  appearance="fill">
                        <mat-label>Reason</mat-label>
                        <mat-select  formControlName="reasons" required>
                           <mat-option  *ngFor="let reason of reasons" [value]="reason">{{reason}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="registerForm.get('reasons').hasError('required')">
                           Please select
                           <strong>Reason</strong>
                         </mat-error>
                     </mat-form-field>  -->
          <mat-form-field appearance="fill">
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phone_no" [(ngModel)]="phone_num" pattern="^\d*[0-9]\d*$" minlength="10" maxlength="10" required />
            <mat-error *ngIf="registerForm.get('phone_no').hasError('required')">
              Please enter phone number
              <!-- <strong>Phone</strong> -->
            </mat-error>
            <mat-error *ngIf="phone_num?.length < 10 && !registerForm.get('phone_no').hasError('required')">
              Please enter 10 digit number
            </mat-error>

          </mat-form-field>
          <!-- <p>Citations issued between 2:00 A.M. - 6:00 A.M. will not be waived if the citation is issued prior to the
            time an overnight parking waiver is requested. Vehicles MUST be parked legally (i.e. not in front of a fire
            hydrant, mailbox, etc.).
            Waivers are not valid when snowfall exceeds 2".
            For questions about overnight parking or parking restrictions, please visit <a href="http://www.villageofvolo.com/parking" target="_blank">www.villageofvolo.com/parking </a>.
          </p> -->
          <p class="black-font">All information must match your vehicle registration card. Inconsistent information will result in revocation of your waiver.</p>
          <!-- <p>Sorry please fill above all details</p> -->
          <button mat-button [disabled]='registerForm.invalid' class="button-primary" type="submit"
            color="vov-ui-primary">Submit</button>
        </div>
      </form>
    </div>
  </div>

</div>
<ng-template #confirmRef>
  <div class="dialog-Container" style="margin-top:-20px;"> 
    <mat-dialog-actions  class="d-inline-block float-right">
      <h4 class="d-inline-block" style="color:#6A0721">Confirmation</h4>
       <!-- <button mat-dialog-close class="dialog-btn-trans text-white">X</button> -->
     </mat-dialog-actions>    
  <mat-dialog-content class="delete-Conatiner">
     <p class="dialog-cls">Please click on the verification link sent to your email address for validation. If you have not received an email, please check email spam/junk folder.</p>
     <div style="text-align:center;padding-top:10px;"><button mat-button style="background-color: #6A0721;cursor: pointer;" (click)="onClose()" class="confirm-btn">Ok</button></div>
    </mat-dialog-content>
  </div>
</ng-template> 
